"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    DialogLoading: ()=>DialogLoading
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const react_namespaceObject = require("motion/react");
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const external_react_namespaceObject = require("react");
const HotelLoadingSkeletonComponent_js_namespaceObject = require("./components/Loading/HotelLoadingSkeletonComponent.js");
const CustomMarkdown_js_namespaceObject = require("./components/MarkdownComponent/CustomMarkdown.js");
const index_js_namespaceObject = require("./components/TryAgain/index.js");
var index_js_default = /*#__PURE__*/ __webpack_require__.n(index_js_namespaceObject);
const useLoadingStateContext_js_namespaceObject = require("./hooks/useLoadingStateContext.js");
const external_ScrollIntoView_js_namespaceObject = require("./ScrollIntoView.js");
const external_StyledLoadingBubble_js_namespaceObject = require("./StyledLoadingBubble.js");
const external_TravelBotLogoImage_js_namespaceObject = require("./TravelBotLogoImage.js");
const DialogLoading = (props)=>{
    const [showTryAgain, setShowTryAgain] = (0, external_react_namespaceObject.useState)(false);
    const hasContentInStreamingText = props.streamingText?.trim() && props.streamingText?.replaceAll('\n', '');
    const showEllipsis = !hasContentInStreamingText;
    const ellipsisProps = {
        width: '10px',
        height: '10px',
        borderRadius: '5px',
        bg: '#868d95'
    };
    const { loadingHotelSkeleton } = (0, useLoadingStateContext_js_namespaceObject.useLoadingStateContext)();
    const TIMEOUT = props.timeout || 120000;
    const MessageIcon = function() {
        return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_TravelBotLogoImage_js_namespaceObject.TravelBotLogoImage, {});
    };
    (0, external_react_namespaceObject.useEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            setShowTryAgain(true);
        }, TIMEOUT);
        return ()=>clearTimeout(timeoutId);
    }, []);
    (0, external_react_namespaceObject.useEffect)(()=>{
        if (!showEllipsis) setShowTryAgain(false);
    }, [
        showEllipsis
    ]);
    const hasLoadingStatusMessages = Array.isArray(props?.loadingStatusMessages) && props?.loadingStatusMessages?.length > 0;
    const lastStatus = props.loadingStatusMessages?.[props.loadingStatusMessages?.length - 1];
    return showTryAgain ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ScrollIntoView_js_namespaceObject.ScrollIntoView, {
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_js_default(), {
            lastMessage: `DialogLoading - Component (timeout set to ${TIMEOUT}):: ${props?.lastMessage || 'unknown lastMessage'}`
        })
    }) : /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
        children: [
            hasLoadingStatusMessages && !hasContentInStreamingText && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.ChatMessage, {
                mb: 40,
                Icon: MessageIcon,
                variation: "initial",
                message: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Flex, {
                    alignItems: 'center',
                    pl: '4px',
                    children: [
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
                            width: 24,
                            height: 24,
                            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Spinner, {
                                size: 24
                            })
                        }),
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                            fontSize: 2,
                            ml: 2,
                            children: lastStatus
                        })
                    ]
                })
            }),
            loadingHotelSkeleton && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(HotelLoadingSkeletonComponent_js_namespaceObject.HotelLoadingSkeletonComponent, {
                isMobile: props.isMobile
            }),
            (hasContentInStreamingText || !hasLoadingStatusMessages && showEllipsis) && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.ChatMessage, {
                mb: 40,
                Icon: MessageIcon,
                variation: "initial",
                message: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Box, {
                    children: [
                        hasContentInStreamingText && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(CustomMarkdown_js_namespaceObject.CustomMarkdown, {
                            children: props.streamingText
                        }),
                        showEllipsis && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(react_namespaceObject.motion.div, {
                            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_StyledLoadingBubble_js_namespaceObject.StyledLoadingBox, {
                                mt: 1,
                                bg: "background.light",
                                width: "62px",
                                height: "32px",
                                alignItems: "center",
                                justifyContent: "space-between",
                                children: [
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
                                        ...ellipsisProps,
                                        id: "ellipses_1"
                                    }),
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
                                        ...ellipsisProps,
                                        id: "ellipses_2"
                                    }),
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
                                        ...ellipsisProps,
                                        id: "ellipses_3"
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
exports.DialogLoading = __webpack_exports__.DialogLoading;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "DialogLoading"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
